<mat-card class="notification-card mat-elevation-z4" [ngClass]="{
    error : notification.level.toString() == NotificationLevelEnum[NotificationLevelEnum.ERROR]
  }">
  <mat-card-content>
    <div class="notification-container">
      <div class="title">
        <div class="icon-and-text">
          <span [ngSwitch]="notification.level.toString()">
            <mat-icon *ngSwitchCase="NotificationLevelEnum[NotificationLevelEnum.INFO]">info </mat-icon>
            <mat-icon *ngSwitchCase="NotificationLevelEnum[NotificationLevelEnum.SUCCESS]">check_circle</mat-icon>
            <mat-icon *ngSwitchCase="NotificationLevelEnum[NotificationLevelEnum.ERROR]">error</mat-icon>
            <mat-icon *ngSwitchCase="NotificationLevelEnum[NotificationLevelEnum.WARNING]">warning</mat-icon>
          </span>
          <span class="title-text">{{'mainNav.notificationsMenu.' + notification.level.toString().toLowerCase() | translate }}</span>
          <span *ngIf="notification.userId == null">
            <mat-icon>local_hospital</mat-icon>
          </span>
        </div>
        <div class="icon-and-text">
          <div class="date">{{ isToday(notification.createdAt) ? (notification.createdAt | dateLocale:'shortTime') : (notification.createdAt | dateLocale:'medium')  }}</div>
          <mat-icon class="close-button" (click)="closeNotification(notification.id)">close</mat-icon>
        </div>
      </div>

      <div [ngSwitch]="notification.code" class="message">

        <ng-container *ngSwitchCase="'NEW_STUDY'">
          {{'mainNav.notificationsMenu.' + notification.code.toLowerCase() | translate }}
          <span class="message-details">{{getPatientName()}}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'WELCOME'">
          {{'mainNav.notificationsMenu.' + notification.code.toLowerCase() | translate }}
          <span class="message-details">{{notification.param}}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'SHARE_STUDY'">
          {{'mainNav.notificationsMenu.' + notification.code.toLowerCase() | translate }}
          <span class="message-details">{{getInfoShareStudy()}}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'SCC_STUDY_START_REVIEW'">
          {{'mainNav.notificationsMenu.' + notification.code.toLowerCase() | translate }}
          <span class="message-details">{{ 'scc.notifications.scc_study_start_review.message' | translate:{ reference: notification.param } }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'SCC_STUDY_NEED_REVIEW'">
          {{'mainNav.notificationsMenu.' + notification.code.toLowerCase() | translate }}
          <span class="message-details">{{ 'scc.notifications.scc_study_need_review.message' | translate:{ reference: notification.param } }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'SCC_STUDY_NEW_REVIEW'">
          {{'mainNav.notificationsMenu.' + notification.code.toLowerCase() | translate }}
          <span class="message-details">{{ 'scc.notifications.scc_study_new_review.message' | translate:{ reference: notification.param } }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'TEXT'">
          {{ getTextMessage() }}
        </ng-container>
        <ng-container *ngSwitchCase="'UPDATE'">
          {{'mainNav.notificationsMenu.' + notification.code.toLowerCase() | translate }}
          <br>
          <hr>
          <span class="preserve-whitespace">{{ notification.param }}</span>
        </ng-container>
        <ng-container *ngSwitchDefault>{{notification.param}}</ng-container>
      </div>

      <div class="notification-footer">

        <div [ngSwitch]="notification.code" class="study-link">

          <ng-container *ngSwitchCase="'SHARE_ALBUM'">
            <a mat-raised-button color="primary" [routerLink]="['/album-cases', notification.url]" *ngIf="notification.url && notification.code === 'SHARE_ALBUM'">{{ 'mainNav.notificationsMenu.action.view_album' | translate }}</a>
          </ng-container>

          <ng-container *ngSwitchCase="'NEW_STUDY'">
            <a mat-raised-button color="primary" [routerLink]="['/viewer', notification.url]" *ngIf="notification.url ">{{ 'mainNav.notificationsMenu.action.view' | translate }}</a>
          </ng-container>

          <ng-container *ngSwitchCase="'SCC_STUDY_START_REVIEW'">
            <a mat-raised-button color="primary" [routerLink]="['/edit-report', notification.url]" *ngIf="notification.url ">{{ 'mainNav.notificationsMenu.action.view' | translate }}</a>
          </ng-container>

          <ng-container *ngSwitchCase="'SCC_STUDY_NEED_REVIEW'">
            <a mat-raised-button color="primary" [routerLink]="['/edit-report', notification.url]" *ngIf="notification.url ">{{ 'mainNav.notificationsMenu.action.view' | translate }}</a>
          </ng-container>

          <ng-container *ngSwitchCase="'SCC_STUDY_NEW_REVIEW'">
            <a mat-raised-button color="primary" [routerLink]="['/edit-report', notification.url]" *ngIf="notification.url ">{{ 'mainNav.notificationsMenu.action.view' | translate }}</a>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <a mat-raised-button color="primary" [href]="notification.url" *ngIf="notification.url ">{{ 'mainNav.notificationsMenu.action.go_to' | translate }}</a>
          </ng-container>

        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
